export default __webpack_public_path__ + "static/media/gallery-image-7-full.bb1b8546.jpg";